import { IHeadCell } from 'common/interfaces/table';

export const HEADER_ACTIONS_OPTION: IHeadCell = {
  id: 'actions',
  label: '',
  sort: false,
  padding: 'none',
  align: 'center',
};
